import { type CommonConfig, type EnvironmentConfig } from "./enviroments.interface";

const DOMAINS = {
  ES: "https://dm.apuestas.codere.es",
  PA: "https://dm.apuestas.codere.es",
  CO: "https://q.mx.bet.cdrsbg.com",
  AR: "https://qm.codere.com.ar",
  MENDOZA: "https://qm.mdz.codere.bet.ar",
};

const COUNTRIES = {
  ES: "Es",
  PA: "Pa",
  CO: "Co",
  AR: "Ar",
  MENDOZA: "Mendoza",
};

const COUNTRY_NAME = "es";

const URLBASE_REPORTS = (domain: string, country: string = "") => `${domain}/csbgonlinereports${country}/`;
const JACKPOTSSERVICES = (domain: string, country: string = "") =>
  `${domain}/JackpotServices.AppService${country}/`;
const URLBASE_BONUS = (domain: string, country: string = "") => `${domain}/csbgonlinecasinobonuses${country}/`;

const commonConfig: CommonConfig = {
  CORDOVA: false,
  COOKIES: {
    customOK: true,
    analyticsOK: false,
    advertismentOK: false,
  },
  DEBUG_MODE: true,
  //refresh times
  TK_RT: 3 * 1000,
  TK_DESK_RT: 5 * 1000,
  LIVE_RT: 5 * 1000,
  HOME_RT: 10 * 1000,
  DEVICE_TYPE: "web",
  BROWSER: "",
  HTTP_ERRORS_THAT_RESTART_APP: [102, 103, 400, 401, 402, 403, 405, 500],
  ERROR_TRACKER_INTERCEPTOR_URLS_2_INSPECT: ["betslipservice"],
  HTTP_ERROR_DESCRIPTION: "Http error an call",
  TIMEOUT_INTERCEPTOR_URLS_2_INSPECT: ["betslipservice"],
  ENABLE_TIMEOUT_FOR_BACKEND_CALLS: true,
  TIMEOUT_FOR_BACKEND_CALLS_IN_MSECS: 5000,
  TIMEOUT_ERROR_DESCRIPTION: "Timeout Error",
  ENABLE_TRACE_CALL_TIME: false,
  MONDAY_TOKEN:
    "eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjUwODc4Nzc5MywiYWFpIjoxMSwidWlkIjoyNTA0NzMzOCwiaWFkIjoiMjAyNS0wNS0wNlQwODoyMToxMC44NzNaIiwicGVyIjoibWU6d3JpdGUiLCJhY3RpZCI6MTAwNzAyNTksInJnbiI6InVzZTEifQ.Vc22PMg_JGy4DFDtjRW86IG5d5nnaGj5DJWxzSROTO4",
  MONDAY_BOARD_ID: 8626683427,
};

const enviromentSportURL = (domain: string, country: string, decoupling?: boolean) => {
  return {
    BETSLIPSERVICEBASEURL:
      "https://dev02.preproduction02.pbs-master.com/dig-codere/betslipservice-gatewayv3/api/v3/",
    CODERE_FANTASY_HP_URL: "https://codere.dgafantasy-dev.com/league?operatorKey=codere",
    CODERE_FANTASY: `${domain}/CodereFantasy/api/`,
    FREEBET_BONUS: `${domain}/FreebetBonus${country === COUNTRIES.AR ? "" : country}/`,
    NAVIGATIONSERVICEBASEURL: "https://coderenavigationserviceredundant.azurewebsites.net/",
    SPORTS_MISC: `${domain}/SportsMisc/api/`,
    URLBASE_MYBETS: "https://coderesbgonlinebettingservicehub20180308-coderesbgonlinebet.azurewebsites.net",
    URLBASE_NEW_MYBETS: "https://coderesportsmyticketsqalinux.azurewebsites.net/api",
    URLBASE_SPORSTMISC: decoupling
      ? `${domain}/SportsMisc${country === COUNTRIES.PA ? country : ""}/api/`
      : `${domain}/SportsMisc/api/`,
    URLBASE_STREAMING: decoupling
      ? `${domain}/StreamingApi${country === COUNTRIES.PA ? country : ""}/`
      : `${domain}/StreamingApi/`,
    URLBASE_BETPLACEMENT: decoupling
      ? `${domain}/BetPlacement${country === COUNTRIES.PA ? country : ""}/`
      : `${domain}/BetPlacement/`,
  };
};

const enviromentMsoURLDecoupling = (domain: string, country?: string) => {
  const prefix = country === COUNTRIES.PA ? ".pa" : country === COUNTRIES.ES ? ".es" : "";
  return {
    URLBASE_SIGNUP_DECOUPLING: `${domain}/services.accounts.signup${prefix}`,
    URLBASE_LOGIN_DECOUPLING: `${domain}/services.accounts.login${prefix}`,
    URLBASE_PROFILE_DECOUPLING: `${domain}/services.players.profile${prefix}`,
    URLBASE_BANNERS_DECOUPLING: `${domain}/services.banners${prefix}`,
  };
};

const enviromentMsoURL = (domain: string, country: string) => {
  const {
    URLBASE_LOGIN_DECOUPLING,
    URLBASE_PROFILE_DECOUPLING,
    URLBASE_SIGNUP_DECOUPLING,
    URLBASE_BANNERS_DECOUPLING,
  } = enviromentMsoURLDecoupling(domain, country);
  return {
    URL_USERDATA_USER_SERVICE: "player/GetUserData",
    URL_USERDATA_USER_SERVICE_STANDALONE: "userdata",
    URLBASE_USERSERICE_STAND_ALONE: domain + "/user/api/data/",
    URLBASE_LOGINSERVICES: domain + `/LoginServices${country.toUpperCase()}Api`,
    URLBASE_BANNERS: domain,
    URL_GEOLOCATION_API: "https://coderesbgonlinegeoip.azurewebsites.net/ips/currentRequestCountryIsoCode",
    URL_SIGNUP_DECOUPLING: `${URLBASE_SIGNUP_DECOUPLING}/signup`,
    URL_PREVALIDATESIGNUP_DECOUPLING: `${URLBASE_SIGNUP_DECOUPLING}/prevalidatesignup`,
    URL_LOGOUT_DECOUPLING: `${URLBASE_LOGIN_DECOUPLING}/logout`,
    URL_REFRESHCOOKIE_DECOUPLING: `${URLBASE_LOGIN_DECOUPLING}/login/refreshcookie`,
    URL_LIMITSAPPLYREQUESTCHANGE_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/limits/applyrequestchange`,
    URL_LIMITSCASINOREQUESTCHANGE_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/limits/casinosessions/requestchange`,
    URL_LIMITSDEPOSITSREQUESTCHANGE_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/limits/deposits/requestchange`,
    URL_GETLIMITS_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/limits`,
    URL_APPLYLIMITS_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/limits/applysurvey`,
    URL_INFOPLAYER_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/infoplayer`,
    URL_SELFEXCLUSION_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/selfexclusion`,
    URL_COMPLIANCE_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/compliance/data/all`,
    URL_CODEREIDTRACKERS_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/trackers`,
    URL_LOGIN_DECOUPLING: `${URLBASE_LOGIN_DECOUPLING}/login/web`,
    URL_LOGIN_NATIVE_DECOUPLING: `${URLBASE_LOGIN_DECOUPLING}/login/native`,
    URL_LOGIN_DECOUPLING_AUTO: `${URLBASE_LOGIN_DECOUPLING}/login/auto`,
    URL_AUTHORIZE_GENERATE_COOKIE_DECOUPLING: `${URLBASE_LOGIN_DECOUPLING}/login/authorize`,
    URL_BANNERS_DECOUPLING: `${URLBASE_BANNERS_DECOUPLING}/banners/templates`,
    URL_QUICKEXIT_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/selfexclusion/salidarapida`,
    URL_TIMEOUTE_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/selfexclusion/tiempofuera`,
    URL_TIMEOUTFORBIDDENACTIONS_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/selfexclusion/tiempofuera/forbiddenactions`,
    URL_COMMUNICATIONS_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/communicationoptions`,
    URL_COMERCIALCOMMUNICATION_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/commercialcommunications`,
    URL_REACTIVEACCOUNT_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/prohibited/reactivate`,
    URL_USERDATA_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/data`,
    URL_LINKRESETPASSWORD_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/password/link`,
    URL_CHANGEPASSWORD_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/password/change`,
    URL_FORGOTPASSWORD_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/password/forgot`,
    URL_PROMOTIONS_OPTOUT_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/promotions/optout`,
    URL_PROMOTIONS_OPTIN_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/promotions/optin`,
    URL_PROMOTIONS_CHECKOPTIN_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/promotions/checkoptin`,
    URL_PROMOTION_ACTIVES_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/promotions/actives`,
    URL_ISPROMOTABLE_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/promotable`,
    URL_ISPROMOTABLEVIP_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/promotable/vip`,
    URL_QRCODE_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/profile/qrcode`,
    URL_TERMSANDCONDITIONS_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/termsandconditions`,
    URL_TERMSANDCONDITIONS_SELFIE_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/termsandconditions/selfie`,
    URL_PRIVACYPOLICY_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/termsandconditions/privacypolicy`,
    URL_RENAMEKEY_DECOUPLING: `${URLBASE_PROFILE_DECOUPLING}/cookie/renamekey`,
    URL_CHECKDATAAVAILABILITY_DECOUPLING: `${URLBASE_SIGNUP_DECOUPLING}/signup/checkdataavailability?field={1}&value={2}`,
  };
};

const enviromentCasinoURL = (domain: string, country: string = "", decoupling?: boolean) => {
  return {
    LOBBY_JACKPOTS: domain + "/Jackpot/",
    JACKPOTSSERVICES: JACKPOTSSERVICES(domain, country),
    LOBBY_JACKPOTS_TICKERS: JACKPOTSSERVICES(domain, country) + "/api/NewJackpot/",
    LIVEGAMEDATA: domain + "/LiveGameData",
    DYNAMICYIELD: URLBASE_REPORTS(domain, country.toLowerCase()) + "slotgames/GetGamesDY?mobile=",
    RECENTGAMES: URLBASE_REPORTS(domain, country.toLowerCase()) + "slotgames/GetGamesRPG?mobile=",
    URLBASE_BALANCESERVICE_API: "/BalanceServiceApi/",
    URLBASE_CASINO_BONUSES: URLBASE_BONUS(domain, country.toLowerCase()),
    URLBASE_CODERE_EVENT_BUS: "https://coderesbgonlineeventbusapi.azurewebsites.net/api",
    ROYALDEGREE: "https://newarchpocapimanagement.azure-api.net",
  };
};

const enviromentPaymentsURL = (domain: string, country: string) => {
  const use_country = country === COUNTRIES.AR ? "Caba" : country;
  return {
    URLBASE_TRANSACTIONS_API: `/PaymentsTransactionsApiQA${use_country}/`,
    URLBASE_TRANSACTIONS_API_PRAXIS_DEPOSITS: `/PaymentsTransactionsApiQA${use_country}/praxis/deposit`,
    URLBASE_OPERATIONS_API: "/payments/operations/",
    URLBASE_VERIDAS_API: domain + "/veridas/",
    URLBASE_NEWVERIDAS_API: domain + "/payments/newveridas/api/v1/",
    URLBASE_VERIDAS_MODELS: domain + "/deportes/assets/js/veridas/public/models",
    IOS_REDIRECTION_SUBDOMAIN: `DeportesQa${country}`,
  };
};

const environments: { [key: string]: EnvironmentConfig } = {
  es: {
    ...commonConfig,
    COUNTRY: "es",
    ENVIRONMENT: "qa",
    DOMAIN: DOMAINS.ES,
    URLBASE: DOMAINS.ES + "/csbgonline/",
    URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.ES),
    JACKPOTSSERVICES: JACKPOTSSERVICES(DOMAINS.ES),
    GLOBALS: {
      domainC: "codere.es",
      URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.ES),
      URLBASE: DOMAINS.ES + "/csbgonline/",
      APP_VERSION: "undefined_2025.06.12-7.25.49 AM",
      LICENSE_TYPE: 0,
      ENVIRONMENT: "qa",
      ANDROID_SENDER_ID: "883739471811",
      XTREME_PUSH_APPKEY: "Ogs56aWx9Tov4JZi20wAcasrdMGp0cxC",
      URLBASE_COMMON_API: "/DynTemplateGen/Api/",
      HCP_URL: `${DOMAINS.ES}/DeportesQAEs/hcp/hcp.json`,
      ...enviromentSportURL(DOMAINS.ES, COUNTRIES.ES),
      ...enviromentPaymentsURL(DOMAINS.ES, COUNTRIES.ES),
      ...enviromentCasinoURL(DOMAINS.ES),
      ...enviromentMsoURL(DOMAINS.ES, COUNTRIES.ES),
      URLBASE_USERSERVICE: DOMAINS.ES + "/UserServiceApi/",
      TK_CLOSE: 3 * 1000,
      CASINO_PRAGMATIC_ID: "ppcdz00000006392",
      CASINO_PRAGMATIC_SERVER_ID: "prelive0-dga.pragmaticplaylive.net",
      HIGHLIGHTS_RT: 10 * 1000,
      FORBIDDEN_REDIRECT: DOMAINS.ES + "/csbgonline/home/NotAllowedCountry",
      COUNTRY_AVAILABLE: true,
      TRANSAPI_PointofSalePayment: true,
      TRANSAPI_BankAccountPayment: true,
      TRANSAPI_HalCashPayment: true,
      TRANSAPI_BgtCardPayment: true,

      TRANSAPI_ElectronicCardDeposit: true,
      TRANSAPI_PointofSaleDeposit: true,
      TRANSAPI_TeleingreosDeposit: true,
      TRANSAPI_PaySafeCardDeposit: true,
      TRANSAPI_BgtCardDeposit: true,
      TRANSAPI_CRUDoverTransactions: true,
      EPGCREDITCARDENABLED: true,
      LOBBY_IMAGES: "https://www.codere.es/lobby_tiles/",
      PROVIDER_IMAGES: "https://www.codere.es/IconsCasino/",
      PRODUCTION: false,
      BASEDOMAIN: DOMAINS.ES,
      DEBUG_MODE: true,

      APPINSIGHTS: {
        instrumentationKey: "e93e073e-a7ef-4436-b4b2-7e74aea49733",
      },
      APPSFLYER_APPKEY: "35oCwDbdGrCHzD9kajJMTk",
      APPSFLYER_APPID: "",
      URL_USERDATA_OLD: `${DOMAINS.ES}/csbgonline/account/getuserdata`,
      MONDAY_LICENSE_ANDROID_ID: "8626698100",
      MONDAY_LICENSE_IOS_ID: "8626698228",
    },
  },
  pa: {
    ...commonConfig,
    COUNTRY: "pa",
    ENVIRONMENT: "qa",
    DOMAIN: DOMAINS.PA,
    URLBASE: DOMAINS.PA + "/csbgonlinepa/",
    URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.PA, "pa"),
    JACKPOTSSERVICES: JACKPOTSSERVICES(DOMAINS.PA, COUNTRIES.PA),
    GLOBALS: {
      domainC: "codere.es",
      URLBASE: DOMAINS.PA + "/csbgonlinepa/",
      URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.PA, "pa"),
      APP_VERSION: "undefined_2025.06.12-7.25.49 AM",
      LICENSE_TYPE: 22,
      ENVIRONMENT: "qa",
      ANDROID_SENDER_ID: "219751794811",
      XTREME_PUSH_APPKEY: "UtobDQ0NyPkF6bcSZs8PhTWCFY1BGqnv",
      URLBASE_COMMON_API: "/DynTemplateGen/Api/",
      ...enviromentSportURL(DOMAINS.PA, COUNTRIES.PA, false),
      ...enviromentPaymentsURL(DOMAINS.PA, COUNTRIES.PA),
      ...enviromentCasinoURL(DOMAINS.PA, COUNTRIES.PA, false),
      ...enviromentMsoURL(DOMAINS.PA, COUNTRIES.PA),
      URLBASE_USERSERVICE: DOMAINS.PA + "/UserServiceApi/",
      TK_CLOSE: 3 * 1000,
      CASINO_PRAGMATIC_ID: "",
      CASINO_PRAGMATIC_SERVER_ID: "",
      HCP_URL: `${DOMAINS.PA}/DeportesQAPa/hcp/hcp.json`,

      HIGHLIGHTS_RT: 10 * 1000,
      FORBIDDEN_REDIRECT: DOMAINS.PA + "/csbgonline/home/NotAllowedCountry",
      COUNTRY_AVAILABLE: true,
      TRANSAPI_PointofSalePayment: true,
      TRANSAPI_BankAccountPayment: true,
      TRANSAPI_HalCashPayment: true,
      TRANSAPI_BgtCardPayment: true,

      TRANSAPI_ElectronicCardDeposit: true,
      TRANSAPI_PointofSaleDeposit: true,
      TRANSAPI_TeleingreosDeposit: true,
      TRANSAPI_PaySafeCardDeposit: true,
      TRANSAPI_BgtCardDeposit: true,
      TRANSAPI_CRUDoverTransactions: true,

      EPGCREDITCARDENABLED: true,
      LOBBY_IMAGES: "https://www.codere.es/lobby_tiles/",

      BASEDOMAIN: DOMAINS.PA,
      PROVIDER_IMAGES: "https://www.codere.es/IconsCasino/",

      PRODUCTION: false,
      DEBUG_MODE: true,

      APPINSIGHTS: {
        instrumentationKey: "e93e073e-a7ef-4436-b4b2-7e74aea49733",
      },
      APPSFLYER_APPKEY: "35oCwDbdGrCHzD9kajJMTk",
      APPSFLYER_APPID: "1498747318",
      URL_USERDATA_OLD: `${DOMAINS.PA}/csbgonlinepa/account/getuserdata`,
      MONDAY_LICENSE_ANDROID_ID: "8626698497",
      MONDAY_LICENSE_IOS_ID: "8626698583",
    },
  },
  co: {
    ...commonConfig,
    COUNTRY: "co",
    ENVIRONMENT: "qa",
    DOMAIN: DOMAINS.CO,
    URLBASE: DOMAINS.CO + "/csbgonlineco/",
    URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.CO, "co"),
    JACKPOTSSERVICES: JACKPOTSSERVICES(DOMAINS.CO, COUNTRIES.CO),
    GLOBALS: {
      domainC: "codere.co",
      URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.CO, "co"),
      URLBASE: DOMAINS.CO + "/csbgonlineco/",
      URLBASE_REGCONEW: `${DOMAINS.CO}/csbgonlineco/RegistroCo`,
      APP_VERSION: "undefined_2025.06.12-7.25.49 AM",
      LICENSE_TYPE: 21,
      ENVIRONMENT: "qa",
      ANDROID_SENDER_ID: "1030304331403",
      XTREME_PUSH_APPKEY: "O-LH4IVDK3_H9K8tFfcilBt5_koNHPPm",
      URLBASE_COMMON_API: "/DynTemplateGenCO/Api/",
      ...enviromentSportURL(DOMAINS.CO, COUNTRIES.CO),
      ...enviromentPaymentsURL(DOMAINS.CO, COUNTRIES.CO),
      ...enviromentCasinoURL(DOMAINS.CO, COUNTRIES.CO, true),
      ...enviromentMsoURL(DOMAINS.CO, ""),
      URLBASE_USERSERVICE: DOMAINS.CO + "/UserServiceApiCO/",
      TK_CLOSE: 3 * 1000,
      CASINO_PRAGMATIC_ID: "ppcdz00000005664",
      CASINO_PRAGMATIC_SERVER_ID: "prelive0-dga.pragmaticplaylive.net",
      HCP_URL: `${DOMAINS.CO}/DeportesQACo/hcp/hcp.json`,

      HIGHLIGHTS_RT: 10 * 1000,
      FORBIDDEN_REDIRECT: DOMAINS.CO + "/csbgonline/home/NotAllowedCountry",
      COUNTRY_AVAILABLE: true,
      TRANSAPI_PointofSalePayment: true,
      TRANSAPI_BankAccountPayment: true,
      TRANSAPI_HalCashPayment: true,
      TRANSAPI_BgtCardPayment: true,

      TRANSAPI_ElectronicCardDeposit: true,
      TRANSAPI_PointofSaleDeposit: true,
      TRANSAPI_TeleingreosDeposit: true,
      TRANSAPI_PaySafeCardDeposit: true,
      TRANSAPI_BgtCardDeposit: true,
      TRANSAPI_CRUDoverTransactions: true,

      EPGCREDITCARDENABLED: true,
      LOBBY_IMAGES: "https://www.codere.es/lobby_tiles/",

      BASEDOMAIN: DOMAINS.CO,
      PROVIDER_IMAGES: "https://www.codere.es/IconsCasino/",

      PRODUCTION: false,
      DEBUG_MODE: true,

      APPINSIGHTS: {
        instrumentationKey: "e93e073e-a7ef-4436-b4b2-7e74aea49733",
      },
      APPSFLYER_APPKEY: "35oCwDbdGrCHzD9kajJMTk",
      APPSFLYER_APPID: "",
      URL_USERDATA_OLD: `${DOMAINS.CO}/csbgonlineco/account/getuserdata`,
      URL_AUTHORIZATIONPERSONALDATA_DECOUPLING: `${enviromentMsoURLDecoupling(DOMAINS.CO, COUNTRIES.CO).URLBASE_PROFILE_DECOUPLING}/authorizationpersonaldata`,
      MONDAY_LICENSE_ANDROID_ID: "8626698293",
      MONDAY_LICENSE_IOS_ID: "8626698442",
      URL_POSTSIGNUP_DECOUPLING: `${enviromentMsoURLDecoupling(DOMAINS.CO, COUNTRIES.CO).URLBASE_SIGNUP_DECOUPLING}/postsignup`,
    },
  },
  ar: {
    ...commonConfig,
    COUNTRY: "ar",
    ENVIRONMENT: "qa",
    DOMAIN: DOMAINS.AR,
    URLBASE: DOMAINS.AR + "/csbgonline/",
    URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.AR),
    JACKPOTSSERVICES: JACKPOTSSERVICES(DOMAINS.AR),
    GLOBALS: {
      domainC: "codere.ar",
      URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.AR),
      URLBASE: DOMAINS.AR + "/csbgonline/",
      URLBASE_REGAR: `${DOMAINS.AR}/csbgonline/registroAR`,
      APP_VERSION: "undefined_2025.06.12-7.25.49 AM",
      LICENSE_TYPE: 33,
      ENVIRONMENT: "qa",
      ANDROID_SENDER_ID: "987654321098",
      XTREME_PUSH_APPKEY: "zNkez9WlmYS7OrEp-_J9RD58hO7pdTSo",
      URLBASE_COMMON_API: "/DynTemplateGen/Api/",
      ...enviromentSportURL(DOMAINS.AR, COUNTRIES.AR),
      ...enviromentPaymentsURL(DOMAINS.AR, COUNTRIES.AR),
      ...enviromentCasinoURL(DOMAINS.AR),
      ...enviromentMsoURL(DOMAINS.AR, ""),
      URLBASE_USERSERVICE: DOMAINS.AR + "/UserServiceApi/",
      TK_CLOSE: 3 * 1000,
      CASINO_PRAGMATIC_ID: "",
      CASINO_PRAGMATIC_SERVER_ID: "",
      HCP_URL: `${DOMAINS.AR}/DeportesQACABA/hcp/hcp.json`,

      HIGHLIGHTS_RT: 10 * 1000,
      FORBIDDEN_REDIRECT: DOMAINS.AR + "/csbgonline/home/NotAllowedCountry",
      COUNTRY_AVAILABLE: true,
      TRANSAPI_PointofSalePayment: true,
      TRANSAPI_BankAccountPayment: true,
      TRANSAPI_HalCashPayment: true,
      TRANSAPI_BgtCardPayment: true,

      TRANSAPI_ElectronicCardDeposit: true,
      TRANSAPI_PointofSaleDeposit: true,
      TRANSAPI_TeleingreosDeposit: true,
      TRANSAPI_PaySafeCardDeposit: true,
      TRANSAPI_BgtCardDeposit: true,
      TRANSAPI_CRUDoverTransactions: true,

      EPGCREDITCARDENABLED: true,
      LOBBY_IMAGES: "https://www.codere.es/lobby_tiles/",

      BASEDOMAIN: DOMAINS.AR,
      PROVIDER_IMAGES: "https://www.codere.es/IconsCasino/",

      PRODUCTION: false,
      DEBUG_MODE: true,

      APPINSIGHTS: {
        instrumentationKey: "e93e073e-a7ef-4436-b4b2-7e74aea49733",
      },
      APPSFLYER_APPKEY: "35oCwDbdGrCHzD9kajJMTk",
      URL_USERDATA_OLD: `${DOMAINS.AR}/csbgonline/account/getuserdata`,
      APPSFLYER_APPID: "6743754647",
      MONDAY_LICENSE_ANDROID_ID: null,
      MONDAY_LICENSE_IOS_ID: "8893722411",
    },
  },
  mendoza: {
    ...commonConfig,
    COUNTRY: "mendoza",
    ENVIRONMENT: "qa",
    DOMAIN: DOMAINS.MENDOZA,
    URLBASE: DOMAINS.MENDOZA + "/csbgonline/",
    URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.MENDOZA),
    JACKPOTSSERVICES: JACKPOTSSERVICES(DOMAINS.MENDOZA),
    GLOBALS: {
      domainC: "codere.mendoza",
      URLBASE_REPORTS: URLBASE_REPORTS(DOMAINS.MENDOZA),
      URLBASE: DOMAINS.MENDOZA + "/csbgonline/",
      URLBASE_REGMZA: `${DOMAINS.MENDOZA}/csbgonline/registroMZA`,
      APP_VERSION: "undefined_2025.06.12-7.25.49 AM",
      LICENSE_TYPE: 36,
      ENVIRONMENT: "qa",
      ANDROID_SENDER_ID: "112233445566",
      XTREME_PUSH_APPKEY: "exampleAppKeyForMendoza",
      URLBASE_COMMON_API: "/DynTemplateGen/Api/",
      ...enviromentSportURL(DOMAINS.MENDOZA, COUNTRIES.MENDOZA),
      ...enviromentPaymentsURL(DOMAINS.MENDOZA, COUNTRIES.MENDOZA),
      ...enviromentCasinoURL(DOMAINS.MENDOZA),
      ...enviromentMsoURL(DOMAINS.MENDOZA, ""),
      URLBASE_USERSERVICE: DOMAINS.MENDOZA + "/UserServiceApi/",
      TK_CLOSE: 3 * 1000,
      CASINO_PRAGMATIC_ID: "",
      CASINO_PRAGMATIC_SERVER_ID: "",
      HCP_URL: `${DOMAINS.MENDOZA}/DeportesDevAr/hcp/hcp.json`,

      HIGHLIGHTS_RT: 10 * 1000,
      FORBIDDEN_REDIRECT: DOMAINS.MENDOZA + "/csbgonline/home/NotAllowedCountry",
      COUNTRY_AVAILABLE: true,
      TRANSAPI_PointofSalePayment: true,
      TRANSAPI_BankAccountPayment: true,
      TRANSAPI_HalCashPayment: true,
      TRANSAPI_BgtCardPayment: true,

      TRANSAPI_ElectronicCardDeposit: true,
      TRANSAPI_PointofSaleDeposit: true,
      TRANSAPI_TeleingreosDeposit: true,
      TRANSAPI_PaySafeCardDeposit: true,
      TRANSAPI_BgtCardDeposit: true,
      TRANSAPI_CRUDoverTransactions: true,

      EPGCREDITCARDENABLED: true,
      LOBBY_IMAGES: "https://www.codere.es/lobby_tiles/",

      BASEDOMAIN: DOMAINS.MENDOZA,
      PROVIDER_IMAGES: "https://www.codere.es/IconsCasino/",

      PRODUCTION: false,
      DEBUG_MODE: true,

      APPINSIGHTS: {
        instrumentationKey: "e93e073e-a7ef-4436-b4b2-7e74aea49733",
      },
      APPSFLYER_APPKEY: "35oCwDbdGrCHzD9kajJMTk",
      APPSFLYER_APPID: "changeme",
      URL_USERDATA_OLD: `${DOMAINS.MENDOZA}/csbgonline/account/getuserdata`,
      MONDAY_LICENSE_ANDROID_ID: null,
      MONDAY_LICENSE_IOS_ID: null,
    },
  },
};

const casinoLicense = (license: string, mondayId: string) => {
  const currentLicense: EnvironmentConfig = JSON.parse(JSON.stringify(environments[license]));
  if (currentLicense) {
    currentLicense.COUNTRY = `${license}_casino`;
    currentLicense.GLOBALS.MONDAY_LICENSE_ANDROID_ID = mondayId;
    environments[`${license}_casino`] = currentLicense;
  }
};

casinoLicense("es", "8626698170");

casinoLicense("co", "8626698355");

export const environment: EnvironmentConfig = {
  ...environments[COUNTRY_NAME || "es"],
};
